import type { Company } from './company';

export const CostCenterResourceType = 'cost-center';

export const CostCenterQueryKeys = {
  company: (companyId: Company['id']) => ['CostCenters', companyId],
};

export interface CostCenter {
  id: string;
  name: string;
  createdAt?: string;
  company?: Company;
}

export type CostCenterFilterValue = CostCenter['id'][] | null | undefined;

export interface CostCenterCreate {
  name: string;
  company: {
    id: Company['id'];
  };
}
